import { Component, ElementRef, OnInit, viewChild, ViewChild } from '@angular/core';
import { PaysService } from '../services/pays.service';
import { PaymentInfo } from '../model/paymentInfo';
import { PaymentMethodResponse } from '../model/paymentMethodResponse';
import { CoreConfiguration, Card, GooglePay, ApplePay, Core, CustomTranslations } from '@adyen/adyen-web';
import { AdyenCheckout } from '@adyen/adyen-web';
import { PaymentMethod } from '../model/paymentMethodModel';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { Panel, PanelBeforeToggleEvent } from 'primeng/panel';
import { FormDataService } from '../services/form-data.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { CustomerIdentity } from '../model/customerIdentity';
import { PaymentRequest } from '../model/paymentRequest';
import { PaymentResponse } from '../model/paymentResponse';
import { SharedStateService } from 'src/app/services/shared-state.service';
import { environment } from 'src/environments/environment';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrl: './checkout.component.scss'
})
export class CheckoutComponent implements OnInit {

    paymentInfo : PaymentInfo | undefined;
    paymentMethodResponse: PaymentMethodResponse = new PaymentMethodResponse();
    @ViewChild('adyendiv') adyendiv!: ElementRef;
    @ViewChild('echeck') echeckPanel!: Panel;
    @ViewChild('creditcard') creditcardPanel!: Panel;

    showStateDropdown:boolean=true;
    selectedPM:any = new PaymentMethod();
    paymentMethodResponseBSubject = new BehaviorSubject<boolean>(false);
    showFields:boolean=false;
    identity1Placeholder:string = "";
    customerIdentity1:CustomerIdentity = new CustomerIdentity();
    identity2Placeholder:string = "";
    customerIdentity2:CustomerIdentity = new CustomerIdentity();
    businessNameEntered:boolean = false;
    firstNameLastNameEntered:boolean = false;
    toastTimer:number = 1000 * 60;

    regexZipCode = /^\d{5}(?:[-\s]\d{4})?$/;

    address:any={street1:'',street2:'',city:'',state:'',countryCode:'US', postalCode:''}
    customer:any={firstName:'',lastName:'',middleName:'',phone:'',email:'', identities: []};
    payment:any;
    achPayment:any={firstName:'',lastName:'',buisnessName:'',
      routingNumber:'',accountNumber:'',verifyRoutingNumber:'',verifyAccountNumber:'' };

    creditcardAvailable:boolean = false;
    applepayAvailable:boolean=false;
    googlepayAvailable:boolean=false;
    echeckAvailable:boolean=false;
    paypalAvailable:boolean=false;
    venmoAvailable:boolean=false;
    termsAndConditionsChecked:boolean=false;

    private _cardValid:boolean = false;

  constructor(
    private paysService: PaysService,
    private formDataService: FormDataService,
    private spinnerService:SpinnerService,
    private messageService: MessageService,
    private sharedService: SharedStateService,
    private router:Router,
    private el: ElementRef,
    private liveAnnouncer: LiveAnnouncer
  ){}

  public usaStatesList:any = null;
  public canadaProvincesList:any = null;
  public countriesList:any;

  ngOnInit(): void {
   this.liveAnnouncer.announce('Paynow Checkout. Please enter your payment information to complete payment.');
   this.spinnerService.showSpinner();
   this.paymentInfo = this.sharedService.getState('paymentInfo') ?? null;
   this.identity1Placeholder = "Social Security Number";
   this.identity2Placeholder = "Drivers License";
   this.customerIdentity1 = new CustomerIdentity();
   this.customerIdentity2 = new CustomerIdentity();
   this.customerIdentity1.identityTypeId=1;
   this.customerIdentity2.identityTypeId=3;
   this.customerIdentity1.countryCode = "US";
   this.customerIdentity2.countryCode = "US";

   this.messageService.clear('messages');
   this._cardValid = false;
  //  this.form.disable();

   if(this.paymentInfo){

    this.customer.firstName = this.paymentInfo?.firstName;
    this.customer.lastName = this.paymentInfo?.lastName;
    this.customer.middleName = this.paymentInfo?.middleName;
    this.customer.phone = this.paymentInfo?.phone;
    this.customer.email = this.paymentInfo?.email;
    this.usaStatesList = this.formDataService.getUSStateCodes();
    this.canadaProvincesList = this.formDataService.getCanadianProvinceCodes();
    this.countriesList = this.formDataService.getCountryCodes();
    this.customer.countryCode='US';
    this.paysService.paymentMethods(this.paymentInfo).subscribe(
      {
        next:(res)=>{
          this.paymentMethodResponse=res;
          this.creditcardAvailable = this.paymentMethodResponse.paymentMethods.find(p=>p.type=='creditcard')?true:false;
          this.applepayAvailable = this.paymentMethodResponse.paymentMethods.find(p=>p.type=='applepay') && this.displayApplePay?true:false;
          this.googlepayAvailable = this.paymentMethodResponse.paymentMethods.find(p=>p.type=='googlepay')?true:false;
          this.echeckAvailable = this.paymentMethodResponse.paymentMethods.find(p=>p.type=='echeck')?true:false;
          this.paypalAvailable = this.paymentMethodResponse.paymentMethods.find(p=>p.type=='paypal')?true:false;
          this.venmoAvailable = this.paymentMethodResponse.paymentMethods.find(p=>p.type=='venmo')?true:false;
          this.selectedPM=this.paymentMethodResponse.paymentMethods.find(p=>p.type=='creditcard');
          this.spinnerService.hideSpinner();
          this.showFields=true;
        },
        error: (e) => {
          this.spinnerService.hideSpinner();
          this.router.navigate(['/error'])},
        complete: () => this.paymentMethodResponseBSubject.next(true)
      });

   }else{
    this.spinnerService.hideSpinner();
    if(this.sharedService.getState("orderId"))
      this.router.navigate(['/receipt']);
    else
      this.router.navigate(['/error']);
   }
  }

  ngAfterViewInit() {
    this.loadPaymentMethods().subscribe(
      value=>{
        if(value){
          if(this.creditcardAvailable){
            let pm:any = this.paymentMethodResponse.paymentMethods.find(p=>p.type=='creditcard');
            this.creditCardConfig(pm,this.paymentMethodResponse.environment);
          }
          if(this.applepayAvailable){
            let pm:any = this.paymentMethodResponse.paymentMethods.find(p=>p.type=='applepay');
            this.appleConfig(pm ,this.paymentMethodResponse.environment);
          }
          if(this.googlepayAvailable){
            let pm:any = this.paymentMethodResponse.paymentMethods.find(p=>p.type=='googlepay');
            this.googleConfig(pm, this.paymentMethodResponse.environment);
          }
        }
      }
    )

  }

  collapsedEcheckPanel(){
    return this.echeckPanel && this.echeckPanel.collapsed;
  }

  collapsedCreditCardPanel(){
    return this.creditcardPanel && this.creditcardPanel.collapsed;
  }

  loadPaymentMethods(){
    return this.paymentMethodResponseBSubject.asObservable();
  }
  
  get displayApplePay():boolean{
    return (window as any).ApplePaySession !== undefined;
  }

  private async creditCardConfig(pm:PaymentMethod, env:string){
    const cardTranslations:CustomTranslations = {
      "en-US":{
          "creditCard.expiryDate.label":"Expiration Date",
          "cc.dat.912": "Enter a valid expiration date.",
          "cc.dat.913": "Enter a valid expiration date."
        }
    };

    let configuration:CoreConfiguration = {
      showPayButton: false,
      translations: cardTranslations,
      locale: "en-US",
      countryCode:"US",
      environment: env === "test" ? 'test': 'live', // Change to 'live' for the live environment.
      clientKey: environment.adyen_key,
      analytics: {
        enabled: false // Set to false to not send analytics data to Adyen.
      },
      onChange : (state: any, component: any) => {
        this.handleCardChange(state, component, pm);
      }
    };
    //const checkout = await AdyenCheckout(configuration);
    let adyenCore: Promise<Core> = AdyenCheckout(configuration);
    adyenCore.then(
      (checkout)=>{
          const card = new Card(checkout,{
          hasHolderName: true,
          holderNameRequired: true,
          showBrandIcon: true
        }).mount(this.adyendiv.nativeElement)
      },
    (e)=>{
      console.log("Credit card failed to load");
    }
    );
    //await checkout.create('card').mount(this.adyendiv.nativeElement);
  }

  private async googleConfig(pm:PaymentMethod, env:string){
    let googleConfiguration:CoreConfiguration = {
      countryCode:"US",
      locale: "en_US",
      environment: env === "test" ? 'test': 'live', // Change to 'live' for the live environment.
    };

    let merchant_account:string = pm.config.gatewayMerchantId;
    let google_merchant:string = pm.config.merchantId;
    const googleCheckout = await AdyenCheckout(googleConfiguration);
    const googlePay = new GooglePay(googleCheckout,{
      type: 'googlepay',
      buttonType : "pay",
      configuration: {
        gatewayMerchantId: merchant_account,
        merchantId: google_merchant,
        merchantName: 'CiviTekCOM'
      },
      transactionInfo:{
        countryCode: 'US',
        currencyCode: 'USD',
        totalPriceStatus: 'FINAL',
        totalPrice: pm.totalAmount.toString(),
        totalPriceLabel: 'Total'
      },
      onSubmit: async (state, component, actions) => {
        this.handleGooglePayChange(state,actions);
      },
      onPaymentFailed: (e)=>{
        console.log("Google pay payment failed");
        console.log(e);
      }
    });

    googlePay.isAvailable()
      .then(()=>{
        googlePay.mount('#googlepay-container');
      })
      .catch(e => {
        console.log("Google pay failed to load");
        console.log(e);
      });
  }

  public handleCardChange(state:any, component:any, pm:PaymentMethod) {
    this._cardValid = state.isValid;
    if (state.isValid) {
      let paymentInfo = {
        encryptedCardNumber : state.data.paymentMethod.encryptedCardNumber,
        encryptedExpiryMonth : state.data.paymentMethod.encryptedExpiryMonth,
        encryptedExpiryYear : state.data.paymentMethod.encryptedExpiryYear,
        encryptedSecurityCode : state.data.paymentMethod.encryptedSecurityCode,
        cardHolderName : state.data.paymentMethod.holderName
      };
      this.payment= {type:this.selectedPM.type, shopperPaymentInfo:paymentInfo};
    }
  }

  public  handleGooglePayChange(state:any, googleActions:any) {
    console.log(state);
    this.selectedPM = this.paymentMethodResponse.paymentMethods.find(p=>p.type=='googlepay');
    let paymentInfo = {
      "googlePayToken" : state.data.paymentMethod.googlePayToken//,
      //"checkoutAttemptId" : state.data.paymentMethod.checkoutAttemptId
    };
    this.payment= {type:this.selectedPM.type, shopperPaymentInfo:paymentInfo};
    this.makepayment(googleActions);
  }

  togglePanel(event: PanelBeforeToggleEvent,pm:any){
    this.selectedPM = {};
    if(event.collapsed){
        this.selectedPM=this.paymentMethodResponse.paymentMethods.find(p=>p.type==pm);
    }else{
      if(this.googlepayAvailable && pm === "googlepay")
        this.selectedPM = this.paymentMethodResponse.paymentMethods.find(p=>p.type=='googlepay');
      else if(this.applepayAvailable && pm === "applepay")
        this.selectedPM = this.paymentMethodResponse.paymentMethods.find(p=>p.type=='applepay');
    }
  }

  get paymentFieldsReady(){
    if(this.selectedPM.type != undefined){
      if(this.selectedPM.type === 'creditcard'){
        return this._cardValid;
      }

      return true;
    }

    return false;
  }

  private async appleConfig(pm:PaymentMethod, env:string){
    let latestBackendRes: any = null;
    const checkout = await AdyenCheckout({
      locale: "en_US",
      environment:env === 'test' ? 'test' : 'live', // Change to 'live' for the live environment.
      clientKey: environment.adyen_key,
      countryCode:"US",

      amount: {
        currency: 'USD',
        value: Math.round(pm.totalAmount * 100)
      },

      // Global onSubmit (v6 flow control)
      onSubmit: async (state: any, _component: any, actions: any) => {
        try {
          this.spinnerService.showSpinner();
          this.payment = {
            type: 'applepay',
            shopperPaymentInfo: {
              applePayToken: state?.data?.paymentMethod?.applePayToken
            }
          };

          let paymentRequest = new PaymentRequest();
          paymentRequest.payment = this.payment;
          paymentRequest.customer = this.customer;
          paymentRequest.address = this.address;

          // your custom backend call to /payments
          const res = await lastValueFrom(this.paysService.makePayment(paymentRequest));
          latestBackendRes = res;

          const ok = res?.status === 'Success' || res?.status === 'Review';

          // ALWAYS resolve (even when not ok). Reject only for network/Adyen API call failures.
          actions.resolve({
            resultCode: ok ? 'Authorized' : 'Refused'
            // action: res?.action  // include if your backend ever returns an Adyen action
          });
        } catch (e: any) {
          actions.reject(); // only on technical failures
          latestBackendRes = { error: e };
        } finally {
          this.spinnerService.hideSpinner();
        }
      },

      // Navigate ONLY here (after Adyen finalizes Apple Pay)
      onPaymentCompleted: (_result: any, _component: any) => {
        this.spinnerService.hideSpinner();
        const res = latestBackendRes;
        const ok = res?.status === 'Success' || res?.status === 'Review';
        if (!ok) return;

        this.sharedService.changeState('orderId', res.orderId);
        this.paymentInfo=undefined;
        this.router.navigate(['/receipt']);
      },

      onPaymentFailed: (_result: any, _component: any) => {
        const res = latestBackendRes;

        if (res?.retry) {
          this.messageService.add({key: 'messages',  severity: 'error', summary: 'Error', detail: res.errorMessage || 'Payment failed. Please try again.' });
        } else {
          this.spinnerService.hideSpinner();
          this.router.navigate(['/error']);
        }
      },

      onError: (err: any) => {
        console.error('Apple Pay checkout error', err);
        this.spinnerService.hideSpinner();
      }
    });

    const applePay = new ApplePay(checkout, {
      configuration: {
        merchantName: 'CiviTekCOM',
        merchantId: this.selectedPM.config.merchantIdentifier
      },

      onValidateMerchant: (resolve, reject, validationURL) => {
        const body = {
          validationUrl: String(validationURL),
          merchantIdentifier: this.selectedPM.config.merchantIdentifier,
          merchantName: 'CiviTekCOM',
          domain: window.location.hostname
        };
        
        this.paysService.appleValidation(body).subscribe({
          next: (session) => resolve(session),
          error: (err) => {
            console.error('Merchant validation failed', err);
            reject();
          }
        });
      },

      // must resolve to allow checkout.onSubmit to run
      onAuthorized: (_data: any, actions: any) => actions.resolve()
    });

    await applePay.isAvailable();
    applePay.mount('#applepay-container');
  }
  onCountryChange(event: any) {
    this.address.state='';
  }

  submitPaymentForm(){
    if(this.validateForm())
      this.makepayment(null)
  }
  makepayment(googleActions:any){
    if(this.total >= 3000){
      let identities = [this.customerIdentity1, this.customerIdentity2];
      this.customer.identities = identities;
    }

    let paymentRequest = new PaymentRequest();
    paymentRequest.payment = this.payment;
    paymentRequest.customer = this.customer;
    paymentRequest.address = this.address;

    this.spinnerService.showSpinner();
    this.messageService.clear();
    this.paysService.makePayment(paymentRequest).subscribe({
      next:(value: PaymentResponse)=> {
        this.spinnerService.hideSpinner();
        if(value.status=='success'){
          if(this.selectedPM.type === "googlepay" && googleActions){
            googleActions.resolve({
              "resultCode" : "Authorized"
            });
          }
          this.sharedService.changeState("orderId", value.orderId);
          this.paymentInfo=undefined;
          this.router.navigate(['/receipt']);
        }else if(value.status=='failed'){
          if (this.selectedPM.type === "googlepay" && googleActions) {
            googleActions.reject();
          }
          if(value.retry){
            this.messageService.add({key: 'messages',  severity: 'error', summary: 'Error', detail: value.errorMessage });
          }else
            this.router.navigate(['/paymentError']);
        }
      },
      error:(e)=>{
        this.spinnerService.hideSpinner();
        this.router.navigate(['/error']);
      }
    });
  }

  public updateIdentity1Placeholder(){
    this.customerIdentity1.value='';
    switch(this.customerIdentity1.identityTypeId){
      case "1":
        this.identity1Placeholder = "Social Security Number";
        break;
      case "2":
        this.identity1Placeholder = "Passport Number";
        break;
      case "4":
        this.identity1Placeholder = "Alien Registration Number";
        break;
    }
  }

  public updateIdentity2Placeholder(){
    this.customerIdentity2.value='';
    if(this.customerIdentity2.identityTypeId ==="3"){
      this.identity2Placeholder = "Drivers License";
    } else {
      this.identity2Placeholder = "Other Photo Id Number";
    }
  }

  get total(){
    let total = 0;

    if(this.paymentInfo && this.paymentInfo.transactionAmount){
      total = this.paymentInfo.transactionAmount;
    }

    return total;
  }

  public validateForm(): boolean {
    let valid = true;
    if (this.selectedPM.type == 'echeck') {
      this.messageService.clear('messages');
      if (!((this.achPayment.firstName && this.achPayment.lastName) || this.achPayment.businessName)) {
        this.messageService.add({ key: 'messages', severity: 'error', summary: 'Error', detail: "First and Last or Business names required." });
        return false;
      }
      if (this.achPayment.routingNumber && this.achPayment.verifyRoutingNumber) {
        if (this.achPayment.routingNumber !== this.achPayment.verifyRoutingNumber) {
          this.messageService.add({ key: 'messages', severity: 'error', summary: 'Error', detail: "Routing numbers do not match." });
          return false;
        }
      } else {
        this.messageService.add({ key: 'messages', severity: 'error', summary: 'Error', detail: "Routing numbers are required." });
        return false;
      }
      if (this.achPayment.accountNumber && this.achPayment.verifyAccountNumber) {
        if (this.achPayment.accountNumber != this.achPayment.verifyAccountNumber) {
          this.messageService.add({ key: 'messages', severity: 'error', summary: 'Error', detail: "Account numbers do not match." });
          return false;
        }
      } else {
        this.messageService.add({ key: 'messages', severity: 'error', summary: 'Error', detail: "Account numbers are required." });
        return false;
      }
      this.payment = { type: this.selectedPM.type, shopperPaymentInfo: this.achPayment };
    }
    return valid;
  }


  public onChangeFirstNameLastNameEntered(value: any){
    if(value.length > 0){
    this.businessNameEntered = false;
    this.firstNameLastNameEntered = true;
    }else{
      this.businessNameEntered = false;
      this.firstNameLastNameEntered = false;
    }
  }

  public onChangeBusinessNameEntered(value: any){
    if(value.length > 0){
      this.firstNameLastNameEntered = false;
      this.businessNameEntered = true;
    }else{
      this.businessNameEntered = false;
      this.firstNameLastNameEntered = false;
    }

  }

  cancelPayment(){
    window.location.href = String(this.paymentInfo?.cancelURL);
  }

}
